export default __webpack_public_path__ + "static/andy-d127612bf1d7da9e8ebd12564ba87c79.png";